const baseConfig = require('./config');

console.log(`[config] frontend baseConfig:`, baseConfig);

// Try to load local config, use empty objects if not found
let local_base = {};
let local_frontend = {};
try {
  const localConfig = require('./config.local');
  local_base = localConfig.config_base || {};
  local_frontend = localConfig.config_frontend || {};
} catch (error) {
  console.log('No local config found, using empty config');
}

const config_demo = {
  // Demo-specific overrides if needed
};

const config_test = {
  // Test-specific subdomain config
  adminSubdomain: 'admin-test',
  auth0Subdomain: 'sat-auth-test',
  graphqlSubdomain: 'gql-test',
  tookanSubdomain: 'dispatch-api-test',
  returnsSubdomain: 'returns-test',
  conciergeSubdomain: 'concierge-test',
  eventsSubdomain: 'events-test',
  graphqlHttpUrl: 'https://gql-test.hopdrive.io/v1/graphql',
  graphqlWsUrl: 'wss://gql-test.hopdrive.io/v1/graphql',
};

const config_prod = {
  // Production-specific subdomain config
  adminSubdomain: 'admin',
  auth0Subdomain: 'sat-auth',
  graphqlSubdomain: 'gql-alb',
  tookanSubdomain: 'dispatch-api-prod',
  returnsSubdomain: 'returns',
  conciergeSubdomain: 'concierge',
  eventsSubdomain: 'events',
  graphqlHttpUrl: 'https://gql.hopdrive.io/v1/graphql',
  graphqlWsUrl: 'wss://gql.hopdrive.io/v1/graphql',
};

const config = {
  ...baseConfig,

  // Firebase config
  firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
  firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID || '',
  firebaseAuthDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
  firebaseMeasurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || '',
  firebaseMessagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
  firebaseStorageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',

  // iCheckGateway config
  icheckgatewayAppId: process.env.REACT_APP_IC_APP_ID || '',
  icheckgatewayAppSecret: process.env.REACT_APP_IC_APP_SEC || '',

  // Google config
  googleApiKey: process.env.REACT_APP_GOOGLE_API_KEY || '',
  googleMapsKey: process.env.REACT_APP_GOOGLE_KEY || '',
  googlePlacesKey: process.env.REACT_APP_GPLCS || '',

  // Auth0 config
  auth0ClientId: process.env.REACT_APP_A0_CID || '',

  // Accessorial codes
  accessorialCodes: 'delay,fuel,partial,waived,surge,tow,toll,ride,insurance,reimbursement',

  // Environment specific keys
  ...config_test, //opinionated default to test
  ...(baseConfig.appEnv === 'demo' ? config_demo : null),
  ...(baseConfig.appEnv === 'test' ? config_test : null),
  ...(baseConfig.appEnv === 'production' ? config_prod : null),

  // Local must always be last to ensure it overrides all other configs
  ...local_base,
  ...local_frontend,
};

console.log(`[config] frontend composed config:`, config);

module.exports = config;